export default __webpack_public_path__ + "static/twitterSummaryX-e17c39f9b691966374188225cad811ba.jpg";